// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Colors from "../Colors.bs.js";

function toCost(t) {
  return t + 1 | 0;
}

function fromCost(cost) {
  return (
          cost < 5 ? cost : 5
        ) - 1 | 0;
}

function tierColor(tier) {
  switch (tier) {
    case /* Common */0 :
        return Colors.common;
    case /* Uncommon */1 :
        return Colors.uncommon;
    case /* Rare */2 :
        return Colors.rare;
    case /* Epic */3 :
        return Colors.epic;
    case /* Legendary */4 :
        return Colors.legendary;
    
  }
}

export {
  toCost ,
  fromCost ,
  tierColor ,
  
}
/* Colors Not a pure module */
